<div class="ptb-100">
    <div class="container-fluid bg-secondary p-3 d-flex align-items-center">
        <div class="container d-flex align-items-center ">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item text-white"><a class="text-white" href="#">Home</a></li>
                    <li class="breadcrumb-item active text-white" aria-current="page">Applied Jobs</li>
                </ol>
            </nav>
        </div>
    </div><br />
    <div class="container">
        <div class="row ">
            <div class="col-md-12 p_0">
                <div class="vertical-tab" role="tabpanel">

                    <div class="tab-content tabs">
                        <!--Applied Jobs Tab Content-->
                        <div class="tab-pane fade show active">
                            <h3>Applied Jobs</h3>
                            <hr />
                            <div *ngFor="let item of applieddata">
                                <span><b> {{item.WorkingDomains}}</b></span><br /><br />
                                <p><b>{{item.CompanyName}} </b> | <b>Required Position:</b>{{item.RequiredPosition || 'Not defined'}}</p>
                                <p><b>Experience : </b>{{item.MExperience || 'Not defined'}} | {{item.SalaryRange || 'Not defined'}}</p>
                                <p><span><!--<i class="fas fa-map-marker-alt"></i>-->  {{item.CityName}}</span> |<span>{{item.CreatedDate | date:'dd-MM-yyyy'}}</span></p>
                                <p><b>Job Discription : </b>{{item.JobDescription || 'No description available'}}</p>
                                <button class="btn btn-danger upload mt-3">{{item.StatusName}}</button>
                                <hr />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>
